import { queryOptions } from '@tanstack/react-query';

import { api } from '../client';
import { endpoints } from '../endpoints';
import type { AppNotification, NotificationType, Paginated } from '../types';
import { notification as normalizeNotification, paginated, type WireNotification } from '../wire';

export interface NotificationListFilters {
  read?: boolean;
  type?: NotificationType | 'all';
  page?: number;
}

export const notificationQueries = {
  list: (filters: NotificationListFilters = {}) =>
    queryOptions({
      queryKey: ['notifications', filters.read ?? 'all', filters.type ?? 'all', filters.page ?? 1] as const,
      queryFn: async (): Promise<Paginated<AppNotification>> => {
        const { data, meta } = await api.getEnvelope<{ items?: WireNotification[] }>(
          endpoints.me.notifications(),
          {
            query: {
              read: filters.read === undefined ? undefined : filters.read ? 1 : 0,
              type: filters.type && filters.type !== 'all' ? filters.type : undefined,
              page: filters.page ?? 1,
            },
          },
        );
        return paginated(data, meta, normalizeNotification);
      },
    }),

  unreadCount: () =>
    queryOptions({
      queryKey: ['notifications', 'unread-count'] as const,
      queryFn: async () => {
        const payload = await api.get<{ count?: number }>(endpoints.me.notificationsUnreadCount());
        return payload.count ?? 0;
      },
      staleTime: 60_000,
      refetchInterval: 120_000,
    }),
};

export const notificationApi = {
  markRead(id: number) {
    return api.post(endpoints.me.notificationRead(id));
  },
  markAllRead() {
    return api.post(endpoints.me.notificationsReadAll());
  },
  remove(id: number) {
    return api.delete(endpoints.me.notification(id));
  },
};
